<template>
  <!-- Desktop -->
  <div class="sort-bar-skeleton sort-bar-skeleton--desktop bg-white rounded">
    <div class="d-flex flex-wrap align-items-center justify-content-between gap-2">
      <Skeleton width="220px" height="24px" class="mb-2 mb-sm-0" />
      <div class="d-flex flex-wrap flex-sm-nowrap gap-3 align-items-center justify-content-end col-12 col-sm-6 ms-auto">
        <Skeleton width="72px" height="16px" />
        <div>
          <Skeleton width="210px" height="40px" borderRadius="8px" />
        </div>
        <div class="d-flex gap-1">
          <Skeleton width="40px" height="40px" borderRadius="10px" />
          <Skeleton width="40px" height="40px" borderRadius="10px" />
        </div>
      </div>
    </div>
  </div>

  <!-- Mobile / Tablet -->
  <div class="sort-bar-skeleton sort-bar-skeleton--mobile rounded">
    <div class="mobile-header opacity-75">
      <Skeleton class="bg-gray-300" width="24px" height="24px" borderRadius="4px" />
      <Skeleton class="bg-gray-300" width="240px" height="20px" />
    </div>

    <div class="tablet-controls">
      <div class="d-flex align-items-center justify-content-between w-100">
        <Skeleton class="bg-gray-300 opacity-75" width="127px" height="40px"/>
        <div class="d-flex align-items-center gap-3 opacity-75" style="width: 50%;">
          <Skeleton class="bg-gray-300" width="20%" height="20px"/>
          <Skeleton class="bg-gray-300" width="80%" height="40px" borderRadius="10px" />
        </div>
      </div>
    </div>

    <div class="phone-controls opacity-75">
      <Skeleton class="flex-fill bg-gray-300" height="44px" borderRadius="10px" />
      <Skeleton class="flex-fill bg-gray-300" height="44px" borderRadius="10px" />
    </div>
  </div>
</template>

<script setup lang="ts">
import Skeleton from "primevue/skeleton";
</script>

<style scoped lang="scss">
.sort-bar-skeleton {
  padding: 12px 20px;
  margin-bottom: 16px;
}

.mobile-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.sort-bar-skeleton--mobile {
  display: none;
  padding: 0 12px;
}

.tablet-controls {
  display: none;
  align-items: center;
  gap: 12px;
}

.phone-controls {
  display: flex;
  gap: 10px;
}

@media (max-width: 1199px) {
  .sort-bar-skeleton--desktop {
    display: none;
  }

  .sort-bar-skeleton--mobile {
    display: block;
  }

  .tablet-controls {
    display: none;
  }
}

@media (min-width: 768px) and (max-width: 1199px) {
  .tablet-controls {
    display: flex;
  }

  .phone-controls {
    display: none;
  }
}
</style>
